var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",staticStyle:{"width":"100%","height":"100%","overflow":"hidden","position":"absolute"}},[_c('V3DApp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }